/* @flow */

export const toggleSchoolLevelsCollapseItem = (id: string) => ({
  type: 'SCHOOL_LEVELS_COLLAPSE_TOGGLE_ITEM',
  payload: {
    id
  }
});
